import { render, staticRenderFns } from "./BigQueryIntegration.pug?vue&type=template&id=bb3abc38&lang=pug&external"
import script from "./BigQueryIntegration.js?vue&type=script&lang=js&external"
export * from "./BigQueryIntegration.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports